/**
 * @flow
 * @relayHash fa8c9799681d4ba570270ce5d5aaedbb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ShippingPrice_shippingPriceResponseData$ref = any;
export type ShippingPriceRefetchQueryVariables = {|
  sellerProductModelIds?: ?string,
  prefectureCode?: ?string,
  quantities?: ?string,
|};
export type ShippingPriceRefetchQueryResponse = {|
  +calculateShippingPrice: ?{|
    +$fragmentRefs: ShippingPrice_shippingPriceResponseData$ref
  |}
|};
export type ShippingPriceRefetchQuery = {|
  variables: ShippingPriceRefetchQueryVariables,
  response: ShippingPriceRefetchQueryResponse,
|};
*/


/*
query ShippingPriceRefetchQuery(
  $sellerProductModelIds: String
  $prefectureCode: String
  $quantities: String
) {
  calculateShippingPrice {
    ...ShippingPrice_shippingPriceResponseData_42v0Ih
  }
}

fragment ShippingPrice_shippingPriceResponseData_42v0Ih on ShippingPriceSchemaType {
  calculateShippingPrice(sellerProductModelIds: $sellerProductModelIds, prefectureCode: $prefectureCode, quantities: $quantities) {
    itemShippingPrices {
      sellerProductModelId
      shippingPrice
    }
    totalShippingPrice
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sellerProductModelIds",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "prefectureCode",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "quantities",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "prefectureCode",
    "variableName": "prefectureCode"
  },
  {
    "kind": "Variable",
    "name": "quantities",
    "variableName": "quantities"
  },
  {
    "kind": "Variable",
    "name": "sellerProductModelIds",
    "variableName": "sellerProductModelIds"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ShippingPriceRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculateShippingPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "ShippingPriceSchemaType",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ShippingPrice_shippingPriceResponseData",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShippingPriceRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculateShippingPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "ShippingPriceSchemaType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "calculateShippingPrice",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "ShippingPriceResponseSchemaType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "itemShippingPrices",
                "storageKey": null,
                "args": null,
                "concreteType": "shippingPriceItemResponseSchemaType",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellerProductModelId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shippingPrice",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalShippingPrice",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ShippingPriceRefetchQuery",
    "id": null,
    "text": "query ShippingPriceRefetchQuery(\n  $sellerProductModelIds: String\n  $prefectureCode: String\n  $quantities: String\n) {\n  calculateShippingPrice {\n    ...ShippingPrice_shippingPriceResponseData_42v0Ih\n  }\n}\n\nfragment ShippingPrice_shippingPriceResponseData_42v0Ih on ShippingPriceSchemaType {\n  calculateShippingPrice(sellerProductModelIds: $sellerProductModelIds, prefectureCode: $prefectureCode, quantities: $quantities) {\n    itemShippingPrices {\n      sellerProductModelId\n      shippingPrice\n    }\n    totalShippingPrice\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '737fed1528273cf62721f493ec72a6d0';
module.exports = node;
